import React from "react";


const ConceptNoteSectionContainer = ({children}) => {
    return <div className={'mx-2'}>
        {children}
    </div>
}

export default ConceptNoteSectionContainer